import { render, staticRenderFns } from "./ConfigureDataSetField.vue?vue&type=template&id=747c2dc8&scoped=true"
import script from "./ConfigureDataSetField.vue?vue&type=script&lang=js"
export * from "./ConfigureDataSetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c2dc8",
  null
  
)

export default component.exports